import React, { useState, useEffect } from 'react';
import { Alert, Box, Text, Flex, Button } from '@mantine/core';
import { Trans, useTranslation } from 'react-i18next';

const MEDICAL_OVERVIEW_DISMISSED_KEY = 'warning-medical-overview-dismissed';

interface AppMedWarningProps {
  storageKey?: string;
  messageKey?: string;
}

export const AppMedWarning: React.FC<AppMedWarningProps> = ({
  storageKey = MEDICAL_OVERVIEW_DISMISSED_KEY,
  messageKey = 'warning.appmedDisclaimer',
}) => {
  const { t } = useTranslation();
  const [isDismissed, setIsDismissed] = useState(false);

  // Check localStorage on component mount
  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(storageKey);
      if (dismissed === 'true')
        setIsDismissed(true);

    } catch (error) {
      console.error('Error reading warning dismissal state from localStorage:', error);
    }
  }, [storageKey]);

  // Handle button click to dismiss warning
  const handleDismiss = () => {
    try {
      localStorage.setItem(storageKey, 'true');
      setIsDismissed(true);
    } catch (error) {
      console.error('Error saving warning dismissal state to localStorage:', error);
    }
  };

  // Don't render if dismissed
  if (isDismissed)
    return null;
  
  return (
    <Box style={{ width: '100%', flexShrink: 0 }}>
      <Alert
        variant="light"
        color="yellow"
        title={`⚠️ ${t('warning.title')}`}
        style={{
          backgroundColor: '#FFF8E1',
          border: '2px solid #FFB000',
          borderRadius: '8px'
        }}
      >
        <Flex justify="space-between" align="center" gap="md">
          <Text size="xs" style={{ lineHeight: 1.4, flex: 1 }}>
            <Trans
              i18nKey={messageKey}
              components={{
                bold: <Text component="span" fw="bold" />
              }}
            />
          </Text>
          <Button
            size="xs"
            variant="filled"
            color="yellow"
            onClick={handleDismiss}
            style={{
              backgroundColor: '#FFB000',
              color: '#000',
              fontWeight: 'bold',
              flexShrink: 0
            }}
          >
            {t('warning.understand')}
          </Button>
        </Flex>
      </Alert>
    </Box>
  );
}; 